export default {
  en: {
    register: {
      // facebook: 'Complete with Facebook',
      firstname: 'First name',
      lastname: 'Last name',
      birthday: 'When where you born?',
      birthdate: 'Birth day',
      // country: 'Country',
      email: '@:login.email',
      phone: 'Phone number',
      newpassword: 'New password',
      repeatnewpassword: 'Repeat new password',
      password: 'Password',
      repeatpassword: 'Repeat password',
      register: 'Register',
      check: 'Check',
      login: 'Sign in',
      haveaccount: 'Already have an account?',      
      nohaveaccount: 'Don\'t have an account?', 
      // welcome: "Welcome to Vengo! We've send you an email to confirm your email address. You'll need to do this before you can create your first shipment"
      company_exists: 'This company was already registered with Vengo. Only the person who has added the company (the business owner) can log in to Vengofleet. Contact him or her for the login details. <br> If you have any questions do not hesitate to contact Vengo.',
      company_doesnotexist: 'No company was found with this VAT number. Check whether you have entered the correct number (without spaces). If you have any questions, do not hesitate to contact Vengo.',
      agreeterms: 'I agree with the&nbsp;<a href="https://www.vengo.technology/en/terms-and-conditions" target="_blank">terms and conditions</a>.',
      company: {
        company: 'company',
        vat: 'VAT number',
        name: 'Company name',
        address: {
          zip: 'Zip code',
          number: 'Number',
          box: 'Box',
          city: 'City',
          country: 'Country',
          street: 'Street'
        }
      }
    }
  },
  nl: {
    register: {
      // facebook: 'Vervolledig met Facebook',
      firstname: 'Voornaam',
      lastname: 'Achternaam',
      birthday: 'Wanneer ben je geboren?',
      birthdate: 'Geboortedag',
      // country: 'Land',
      email: '@:login.email',
      phone: 'Telefoonnummer',
      newpassword: 'Nieuw wachtwoord',
      repeatnewpassword: 'Herhaal nieuw wachtwoord',      
      password: 'Wachtwoord',
      repeatpassword: 'Herhaal wachtwoord',
      register: 'Registreer',
      check: 'Controleer',
      haveaccount: 'Heb je al een account?',
      nohaveaccount: 'Nog geen account?', 
      login: 'Log in',
      company_exists: 'Dit bedrijf werd al geregistreerd bij Vengo. Enkel de persoon die het bedrijf heeft toegevoegd (de bedrijfseigenaar) kan inloggen op Vengofleet. Contacteer hem of haar voor de logingegevens.<br>Indien u vragen heeft aarzel dan niet om Vengo te contacteren.',
      company_doesnotexist: 'Er werd geen bedrijf gevonden met dit BTW-nummer. Controleer of u het juiste nummer hebt ingegeven (zonder spaties).<br>Indien u vragen heeft aarzel dan niet om Vengo te contacteren.',
      // welcome: "Welkom bij Vengo! We hebben je een mail verstuurd. Als je die opent en op de bevestig-knop klikt kan je je eerste zending aanmaken."
      agreeterms: 'Ik ga akkoord met de&nbsp;<a href="https://www.vengo.technology/nl/algemene-voorwaarden" target="_blank">algemene voorwaarden</a>.',
      company: {
        company: 'bedrijf',
        vat: 'BTW-nummer',
        name: 'Bedrijfsnaam',
        address: {
          zip: 'Postcode',
          number: 'Nummer',
          box: 'Bus',
          city: 'Stad',
          country: 'Land',
          street: 'Straat'
        }
      }
    }
  },
  fr: {
    register: {
      // facebook: 'Complétez avec Facebook',
      firstname: 'Prénom',
      lastname: 'Nom de famille',
      birthday: 'Quelle est votre date de naissance?',
      birthdate: 'Anniversaire',
      // country: 'Pays',
      email: '@:login.email',
      phone: 'Numéro de téléphone',
      newpassword: 'Nouveau mot de passe',
      repeatnewpassword: 'Répétez nouveau mot de passe',      
      password: 'Mot de passe',
      repeatpassword: 'Répétez mot de passe',
      register: 'Registrer',
      check: 'Controler',
      haveaccount: 'Avez-vous déjà un compte?',
      nohaveaccount: 'Pas encore de compte?', 
      login: 'Se connecter',
      company_exists: 'Cette entreprise était déjà enregistrée chez Vengo. Seule la personne qui a ajouté l\'entreprise (le propriétaire de l\'entreprise) peut se connecter à Vengofleet. Contactez-le pour obtenir les informations de connexion. <br>Si vous avez des questions, n\'hésitez pas à contacter Vengo.',
      company_doesnotexist: 'Aucune entreprise n\'a été trouvée avec ce numéro de TVA. Vérifiez si vous avez entré le bon numéro (sans espace).<br>Si vous avez des questions, n\'hésitez pas à contacter Vengo.',
      // welcome: "Bienvenue chez Vengo! Nous vous avons envoyé un e-mail. Si vous l'ouvrez et cliquez sur le bouton de confirmation, vous pouvez créer votre premier envoi."
      agreeterms: 'Je suis d\'accord avec les&nbsp;<a href="https://www.vengo.technology/fr/conditions-generales" target="_blank">conditions generales</a>.',
      company: {
        company: 'Entreprise',
        vat: 'Numéro TVA',
        name: 'Nom de l\'entreprise',
        address: {
          zip: 'Code postal',
          number: 'Numéro',
          box: 'Boîte',
          city: 'Ville',
          country: 'Pays',
          street: 'Rue'
        }
      }
    }
  }
}
